import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEasyFixOrange = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 45 45",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			x: 11.3173,
			y: 13.3563,
			width: 29.5655,
			height: 29.5655,
			rx: 4.59158,
			stroke: "url(#paint0_linear_3034_28236)",
			strokeWidth: 2.06228
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35.3842 21.3625C35.3712 21.3385 35.353 21.3145 35.3322 21.2958C35.2024 21.1622 34.9921 21.1622 34.8623 21.2958L30.3888 25.8976L28.626 24.0841L33.102 19.4796C33.1228 19.4582 33.1383 19.4369 33.1539 19.4128C33.2474 19.2499 33.1955 19.0416 33.0371 18.9455C30.4875 17.3964 27.1487 17.7516 24.9548 20.0058C23.2152 21.7952 22.6389 24.3325 23.2282 26.6134L15.621 34.4389C15.5431 34.519 15.5483 34.6499 15.6288 34.7327L20.0348 39.2651C20.1152 39.3479 20.2451 39.3532 20.3203 39.2731L27.9249 31.4503C30.1448 32.0592 32.6113 31.469 34.3534 29.6768C36.5447 27.42 36.89 23.9853 35.3842 21.3625ZM33.0319 28.3147C31.5234 29.8665 29.2595 30.1656 27.4602 29.2121L27.2317 29.4471L27.2291 29.4445L20.1152 36.7652L18.059 34.6499L24.0331 28.5043C24.0331 28.5043 24.0331 28.507 24.0357 28.507L25.4065 27.0968C24.4796 25.2459 24.7704 22.917 26.2789 21.3652C26.7654 20.8643 27.3513 20.4773 27.9965 20.2307C28.6418 19.9841 29.3311 19.8837 30.0176 19.9363L26.5671 23.4832C26.4112 23.6437 26.3237 23.8613 26.3237 24.0881C26.3237 24.315 26.4112 24.5326 26.5671 24.6931L29.7995 28.0182C29.9555 28.1786 30.167 28.2686 30.3875 28.2686C30.6081 28.2686 30.8196 28.1786 30.9756 28.0182L34.4235 24.4714C34.5196 25.8549 34.0496 27.2704 33.0319 28.3147Z",
			fill: "url(#paint1_linear_3034_28236)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.5507 20.1715L14.643 20.7089C14.43 20.7542 14.2393 20.872 14.1035 21.0423C13.9677 21.2125 13.8952 21.4246 13.8983 21.6424C13.9015 21.8602 13.9802 22.0701 14.1209 22.2363C14.2616 22.4025 14.4556 22.5148 14.6699 22.5538L16.5775 23.0912L17.1149 24.9988C17.1801 25.1843 17.3013 25.345 17.4617 25.4586C17.6221 25.5723 17.8139 25.6333 18.0105 25.6333C18.2071 25.6333 18.3988 25.5723 18.5593 25.4586C18.7197 25.345 18.8409 25.1843 18.9061 24.9988L19.4435 23.0912L21.3063 22.5001C21.4961 22.4393 21.6617 22.3198 21.7792 22.1589C21.8967 21.9979 21.96 21.8038 21.96 21.6045C21.96 21.4052 21.8967 21.2111 21.7792 21.0501C21.6617 20.8891 21.4961 20.7696 21.3063 20.7089L19.4166 20.1715L18.8792 18.2639C18.814 18.0784 18.6928 17.9178 18.5324 17.8041C18.372 17.6905 18.1802 17.6294 17.9836 17.6294C17.787 17.6294 17.5953 17.6905 17.4348 17.8041C17.2744 17.9178 17.1532 18.0784 17.088 18.2639L16.5507 20.1715ZM4.80038 19.5088L3.23307 19.1058C3.04898 19.0776 2.88105 18.9844 2.75973 18.8431C2.6384 18.7018 2.5717 18.5218 2.5717 18.3355C2.5717 18.1493 2.6384 17.9692 2.75973 17.8279C2.88105 17.6866 3.04898 17.5935 3.23307 17.5653L4.80038 17.1265L5.24819 15.5502C5.29549 15.3885 5.39393 15.2465 5.52876 15.1455C5.66358 15.0444 5.82753 14.9898 5.99601 14.9898C6.16449 14.9898 6.32843 15.0444 6.46326 15.1455C6.59809 15.2465 6.69653 15.3885 6.74384 15.5502L7.19164 17.1265L8.75895 17.5653C8.92065 17.6126 9.06266 17.7111 9.1637 17.8459C9.26473 17.9807 9.31934 18.1447 9.31934 18.3131C9.31934 18.4816 9.26473 18.6456 9.1637 18.7804C9.06266 18.9152 8.92065 19.0137 8.75895 19.061L7.19164 19.5088L6.74384 21.0761C6.69653 21.2378 6.59809 21.3798 6.46326 21.4808C6.32843 21.5819 6.16449 21.6365 5.99601 21.6365C5.82753 21.6365 5.66358 21.5819 5.52876 21.4808C5.39393 21.3798 5.29549 21.2378 5.24818 21.0761L4.80038 19.5088ZM9.12134 0.716901L8.13912 4.28239L4.57363 5.26461C4.37022 5.33613 4.19402 5.46903 4.06938 5.64497C3.94473 5.82092 3.87779 6.03122 3.87779 6.24684C3.87779 6.46246 3.94473 6.67276 4.06938 6.8487C4.19402 7.02465 4.37022 7.15755 4.57363 7.22907L8.13912 8.21129L9.12134 11.7768C9.18798 11.9849 9.31903 12.1665 9.49557 12.2954C9.67211 12.4242 9.88501 12.4937 10.1036 12.4937C10.3221 12.4937 10.535 12.4242 10.7116 12.2954C10.8881 12.1665 11.0192 11.9849 11.0858 11.7768L12.068 8.2113L15.6335 7.22907C15.8369 7.15755 16.0131 7.02465 16.1378 6.8487C16.2624 6.67276 16.3294 6.46246 16.3294 6.24684C16.3294 6.03122 16.2624 5.82092 16.1378 5.64498C16.0131 5.46903 15.8369 5.33613 15.6335 5.26461L12.068 4.28239L11.0858 0.716901C11.0192 0.50875 10.8881 0.327151 10.7116 0.198306C10.535 0.0694608 10.3221 2.95002e-05 10.1036 2.94811e-05C9.88501 2.9462e-05 9.67211 0.0694607 9.49557 0.198306C9.31903 0.327151 9.18799 0.50875 9.12134 0.716901Z",
			fill: "url(#paint2_linear_3034_28236)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_3034_28236",
				x1: 14.0932,
				y1: 20.2321,
				x2: 37.814,
				y2: 34.2889,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .100856,
					stopColor: "#FF6868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEB45E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_3034_28236",
				x1: 18.0616,
				y1: 23.3326,
				x2: 33.8396,
				y2: 32.4228,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .100856,
					stopColor: "#FF6868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEB45E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_3034_28236",
				x1: 19.6262,
				y1: 19.2249,
				x2: 3.26546,
				y2: 11.8918,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .100856,
					stopColor: "#FF6868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEB45E"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgEasyFixOrange);
export { ForwardRef as ReactComponent };
